import type { Except } from "type-fest";
import { z } from "zod";
import { providerIdZodSchema } from "../providers/provider-id";
import { userIdZodSchema } from "../users/user-id";
import {
    payRequestRequesterIdFactory,
    payRequestRequesterIdZodSchema,
} from "./pay-request-requester-id";

const payRequestRequesterZodObject = z.object({
    _id: payRequestRequesterIdZodSchema,
    _type: z.literal("PAY_REQUEST_REQUESTER"),
    userId: userIdZodSchema,
    providerId: providerIdZodSchema,
});

type PayRequestRequester = z.infer<typeof payRequestRequesterZodObject>;
const payRequestRequesterZodSchema: z.ZodSchema<PayRequestRequester> =
    payRequestRequesterZodObject;

type PayRequestRequesterFactoryParams = Except<
    PayRequestRequester,
    "_id" | "_type"
>;
const payRequestRequesterFactory = (
    params: PayRequestRequesterFactoryParams,
): PayRequestRequester => {
    return {
        _id: payRequestRequesterIdFactory(),
        _type: "PAY_REQUEST_REQUESTER",
        ...params,
    };
};

export {
    payRequestRequesterFactory,
    payRequestRequesterZodObject,
    payRequestRequesterZodSchema,
};
export type { PayRequestRequester };
